import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import InputGroup from "react-bootstrap/InputGroup";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, GraphUpArrow, Download, Upload, LightningCharge } from "react-bootstrap-icons";
import formatCurrency from "../helpers/currencyHelper";
import IncomesReports from "./reports/IncomesReports";
import ExpensesProjectsReports from "./reports/ExpensesProjectsReports";
import CashFlowReport from "./reports/CashFlowReport";
import { Button } from "react-bootstrap";
import { MAX_YEAR, MIN_YEAR } from "../config/calendar";

const Dashboard = () => {
  const currentYear = new Date().getFullYear();
  const [incomesDataset, setIncomesDataset] = useState(null);
  const [incomesTotalAmount, setIncomesTotalAmount] = useState(0);
  const [expensesProjectsDataset, setExpensesProjectsDataset] = useState(null);
  const [expensesProjectsTotalAmount, setExpensesProjectsTotalAmount] =
    useState(0);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleYearPrevious = () => {
    if (selectedYear > MIN_YEAR) {
      setSelectedYear(selectedYear - 1);
    }
  };

  const handleYearNext = () => {
    if (selectedYear < MAX_YEAR) {
      setSelectedYear(selectedYear + 1);
    }
  };

  const handleIncomesDataset = (dataSet) => {
    setIncomesDataset(dataSet)
    setIncomesTotalAmount(dataSet.totalAmountsSum)
  };

  const handleExpensesProjectsDataset = (dataSet) => {
    setExpensesProjectsDataset(dataSet);
    setExpensesProjectsTotalAmount(dataSet.totalAmountsSum);
  };

  return (
    <Container className="p-3" fluid>
      <Row className="mb-4 justify-content-center">
        <Col xs="auto">
          <InputGroup>
            <Button
              variant="outline-secondary"
              onClick={handleYearPrevious}
              disabled={selectedYear <= MIN_YEAR}
            >
              <ChevronLeft />
            </Button>
            <InputGroup.Text className="bg-white border-start-0 border-end-0 fw-bold">
              {selectedYear}
            </InputGroup.Text>
            <Button
              variant="outline-secondary"
              onClick={handleYearNext}
              disabled={selectedYear >= MAX_YEAR}
            >
              <ChevronRight />
            </Button>
          </InputGroup>
        </Col>
      </Row>

      <Row className="mb-4 g-5">
        <Col xs={12} lg={6} className="mb-4 mb-lg-0">
          <Card className="shadow-sm border-1">
            <Card.Header className="bg-white d-flex justify-content-between align-items-center border-0 pb-0">
              <div className="d-flex align-items-center fw-bold">
                <Download
                  className="text-success me-2"
                  size={20}
                  strokeWidth={4.5}
                />
                <span className="fs-5 fw-bold">
                  <FormattedMessage
                    id="navProjectIncomes"
                    defaultMessage="Projects Income"
                  />
                </span>
              </div>
              <div className="fs-5 fw-bold text-success">
                {formatCurrency(incomesTotalAmount)}
              </div>
            </Card.Header>
            <Card.Body className="pt-2">
              <hr className="my-2 border border-secondary" />
              <div className="p-3 rounded bg-light">
                <IncomesReports
                  onChangeDataset={handleIncomesDataset}
                  yearFrom={selectedYear}
                  yearTo={selectedYear}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} lg={6}>
          <Card className="shadow-sm border-1">
            <Card.Header className="bg-white d-flex justify-content-between align-items-center border-0 pb-0">
              <div className="d-flex align-items-center fw-bold">
                <Upload
                  className="text-danger me-2"
                  size={20}
                  strokeWidth={4.5}
                />
                <span className="fs-5 fw-bold">
                  <FormattedMessage
                    id="navExpensesProjects"
                    defaultMessage="Projects Expenses"
                  />
                </span>
              </div>
              <div className="fs-5 fw-bold text-danger">
                {formatCurrency(expensesProjectsTotalAmount)}
              </div>
            </Card.Header>
            <Card.Body className="pt-2">
              <hr className="my-2 border border-secondary" />
              <div className="p-3 rounded bg-light">
                <ExpensesProjectsReports
                  onChangeDataset={handleExpensesProjectsDataset}
                  yearFrom={selectedYear}
                  yearTo={selectedYear}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4 mt-5">
        <Col>
          <Card className="shadow-sm border-1">
            <Card.Header className="bg-white d-flex justify-content-between align-items-center border-0 pb-0">
              <div className="d-flex align-items-center fw-bold">
                <GraphUpArrow
                  className="text-primary me-2"
                  size={20}
                  strokeWidth={4.5}
                />
                <span className="fs-5 fw-bold">
                  <FormattedMessage
                    id="cashFlow"
                    defaultMessage="Cash Flow"
                  />
                </span>
              </div>
          
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleYearPrevious}
                  disabled={selectedYear <= MIN_YEAR}
                  className="border-0 p-1"
                >
                  <ChevronLeft size={16} />
                </Button>
                <span className="mx-2 fw-bold text-secondary">
                  {selectedYear}
                </span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleYearNext}
                  disabled={selectedYear >= MAX_YEAR}
                  className="border-0 p-1"
                >
                  <ChevronRight size={16} />
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="pt-1 pb-2">
              <hr className="my-2 border border-secondary" />
              <div className="p-3 rounded bg-light">
                <CashFlowReport selectedYear={selectedYear} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

    </Container>
  );
};

export default Dashboard;
